import { useState } from 'react';
import BookingModal from './BookingModal';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    budget: '',
    message: '',
  });
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Let's Create Your Dream Space
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ready to transform your home or office? Reach out to us and let's discuss how we can bring your vision to life with authentic Nigerian design excellence.
          </p>

          {/* Book a Consultation CTA */}
          <div className="mt-8 inline-flex flex-col items-center gap-3">
            <button
              onClick={() => setIsBookingOpen(true)}
              className="inline-flex items-center gap-3 bg-teal-600 text-white px-8 py-4 rounded-full hover:bg-teal-700 transition-all hover:scale-105 font-semibold text-base shadow-lg shadow-teal-200 whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-calendar-check-line text-lg"></i>
              </div>
              Book a Consultation at 40% Off — ₦600,000
            </button>
            <p className="text-sm text-gray-500">
              <span className="line-through text-gray-400 mr-1">₦1,000,000</span>
              <span className="text-teal-600 font-semibold">₦600,000</span>
              <span className="mx-1">·</span>30-minute session · Limited time offer
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Contact Form */}
          <form id="contact-form" data-readdy-form onSubmit={async (e) => {
            e.preventDefault();
            const formDataToSend = new URLSearchParams();
            Object.entries(formData).forEach(([key, value]) => {
              formDataToSend.append(key, value);
            });
            try {
              const response = await fetch('https://readdy.ai/api/public/form/submit/contact-form', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formDataToSend.toString(),
              });
              if (response.ok) {
                alert('Thank you! We\'ll get back to you soon.');
                setFormData({ name: '', email: '', phone: '', service: '', budget: '', message: '' });
              } else {
                alert('Something went wrong. Please try again.');
              }
            } catch {
              alert('Failed to submit. Please check your connection.');
            }
          }} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder="Enter your name" />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder="your.email@example.com" />
            </div>
            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
              <input type="tel" id="phone" name="phone" value={formData.phone} onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm" placeholder="+234 XXX XXX XXXX" />
            </div>
            <div>
              <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">Service Interested In</label>
              <select id="service" name="service" value={formData.service} onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm">
                <option value="">Select a service</option>
                <option value="Residential Design">Residential Design</option>
                <option value="Commercial Design">Commercial Design</option>
                <option value="Renovation">Renovation</option>
                <option value="Consultation">Consultation</option>
              </select>
            </div>
            <div>
              <label htmlFor="budget" className="block text-sm font-medium text-gray-700 mb-2">Project Budget</label>
              <select id="budget" name="budget" value={formData.budget} onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm">
                <option value="">Select your budget range</option>
                <option value="₦500k - ₦2M">₦500k - ₦2M</option>
                <option value="₦2M - ₦5M">₦2M - ₦5M</option>
                <option value="₦5M - ₦15M">₦5M - ₦15M</option>
                <option value="Above ₦15M">Above ₦15M</option>
              </select>
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">Project Details</label>
              <textarea id="message" name="message" value={formData.message} onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })} required rows={4} maxLength={500} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm resize-none" placeholder="Tell us about your project..." />
              <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</p>
            </div>
            <button type="submit" className="w-full bg-teal-600 text-white px-8 py-4 rounded-lg hover:bg-teal-700 transition-colors font-medium whitespace-nowrap cursor-pointer">
              Send Message
            </button>
          </form>

          {/* Contact Info */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Get in Touch</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Visit Our Studio</h4>
                    <p className="text-gray-600">363 Ifeanyi Ugwanyi Crescent, Wuye, Abuja</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Call Us</h4>
                    <p className="text-gray-600">07062910646</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Email Us</h4>
                    <p className="text-gray-600">exquisitespaces@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-teal-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">WhatsApp</h4>
                    <a href="https://wa.me/message/FEG4Q7VZR4W2E1" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 cursor-pointer">
                      Chat with us on WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Follow Us</h4>
              <div className="flex gap-4">
                <a href="https://www.instagram.com/exquisitespaces1?igsh=MWk3M29rdDZ0ZTdkeg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-teal-100 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-gray-700 text-xl"></i>
                </a>
                <a href="https://wa.me/message/FEG4Q7VZR4W2E1" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-teal-100 transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line text-gray-700 text-xl"></i>
                </a>
              </div>
            </div>

            <div className="bg-teal-50 p-6 rounded-lg">
              <h4 className="font-semibold text-gray-900 mb-2">Business Hours</h4>
              <div className="space-y-1 text-sm text-gray-600">
                <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
                <p>Saturday: 10:00 AM - 4:00 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>

            <div className="rounded-lg overflow-hidden w-full h-64">
              <iframe
                src="https://maps.google.com/maps?q=363+Ifeanyi+Ugwanyi+Crescent,+Wuye,+Abuja&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Exquisite Spaces Location"
              ></iframe>
            </div>
            <a
              href="https://maps.app.goo.gl/RpxGEsxj8J18QUX16?g_st=ic"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 w-full bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="ri-map-pin-2-line text-lg"></i>
              Get Directions
            </a>
          </div>
        </div>
      </div>

      <BookingModal isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} />
    </section>
  );
}
